(function() {
    'use strict';

    angular.module("settings")
        .controller('DataImportController', DataImportController);

    DataImportController.$inject = ['dataImportSrvc', 'dataImportConst', 'notificationSrvc'];

    function DataImportController(dataImportSrvc, dataImportConst, notificationSrvc) {
        var self = this;
        self.importStatus = null;

        self.importAll = importAll;
        self.resetImportStatus = resetImportStatus;

        activate();

        function activate() {
            getImportStatus();
        }

        function getImportStatus() {
            dataImportSrvc.dataImportStatus().$promise.then(
                function(response) {
                    self.importStatus = response.data ? dataImportConst.notFinished : dataImportConst.finished;
                }
            );
        }

        function importAll() {
            dataImportSrvc.dataImport().$promise.then(
                function(response) {
                    self.importStatus = response.status ? dataImportConst.notFinished : dataImportConst.finished;
                    notificationSrvc.notification("success", response.data);
                },
                function(response) {
                    notificationSrvc.notification("error", response.data.data);
                }
            );
        }

        function resetImportStatus() {
            dataImportSrvc.dataImportStatusReset().$promise.then(
                function(response) {
                    self.importStatus = response.data ? dataImportConst.notFinished : dataImportConst.finished;
                }
            );
        }
    }
})();
